/**
 * Formats an instant as a `YYYY-MM-DD` calendar date in the given timezone.
 *
 * The "one photo per calendar day" rule is evaluated in the user's own zone,
 * so the client and server must agree on what "today" means. Relying on the
 * host offset would break for travellers and anyone near midnight.
 */
export function localCalendarDate(instant: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(instant);

  const lookup = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((part) => part.type === type)?.value ?? '';

  return `${lookup('year')}-${lookup('month')}-${lookup('day')}`;
}

/** Returns the IANA timezone reported by the browser. */
export function detectTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}
